import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress"

export function Loading({ color = "" }) {
  return (
    <Box sx={{ display: "flex" }}>
      <CircularProgress sx={{ color: color && color }} />
    </Box>
  );
}

export default Loading;
